// Example: Load Rails libraries in Vite.
//
// import * as Turbo from '@hotwired/turbo'
// Turbo.start()
//
// import ActiveStorage from '@rails/activestorage'
// ActiveStorage.start()
//
// // Import all channels.
// const channels = import.meta.globEager('./**/*_channel.js')

// Example: Import a stylesheet in app/frontend/index.css
// import '~/index.css'

import { Application as LiveComponentApplication, WebSocketsTransport } from "@camertron/live-component";
import { Application as StimulusApplication } from "@hotwired/stimulus"
// import { consumer } from "../channels/consumer"

import "app/components/crossword";
import "app/components/flash";
import "app/components/stopwatch";
import "app/components/wordle";
import "app/components/snake";

declare global {
  interface Window {
    Stimulus: StimulusApplication;
    Live: LiveComponentApplication;
  }
}

window.Stimulus = StimulusApplication.start();
window.Live = LiveComponentApplication.start(window.Stimulus);
// window.Live = LiveComponentApplication.start(window.Stimulus, new WebSocketsTransport(consumer, true));
